import util from '../util'

let controller = 'ContaCorrentistas'

export default Object.assign({}, util.GetCrud(controller, null), {
  GetByConta: function (codigoConta) {
    return util.Axios.Get(controller + '/GetByConta', codigoConta)
  },
  AlterarContaCorrentista: function (codigo, dto) {
    return util.Axios.Put(`${controller}/AlterarContaCorrentista`, codigo, dto)
  },
  GetCorrentistaTitular: function (codigoConta) {
    return util.Axios.Get(controller + '/GetCorrentistaTitular', codigoConta)
  },
  RetornoTitularidadeContas: function (dto) {
    return util.Axios.GetAll(`${controller}/RetornoTitularidadeContas`, dto)
  }
})
